export default {
  message: {
    changeLanguage: 'Switch to Chinese',
    homepage: {
      module_1_title: 'LOONG: LLM-powered autOnomous Optical Network aGent',
      module_1_text: `LOONG is a field trial project aimed at developing an intelligent agent for L4 and L5 level autonomous driving optical networks. Our objective is to create near-realistic demonstrations that bridge the gap between academia and industry, facilitating the deployment of various advanced network management applications that utilize AI techniques. We aim to design and implement a diverse range of advanced algorithms on the testbed to showcase the potential of using AI for Autonomous Driving Optical Networks`,
      news: {
        item1: {
          title:'The website of LOONG project is established!',
          time: '[01/2025]'
        },
        item2: {
          title: 'Two papers based on LOONG testbed are accepted by OFC 2025!',
          time: '[12/2024]'
        },
        item3: {
          title: 'We are happy to share our latest work named “First Field Trial of LLM-Powered AI Agent for Lifecycle Management of Autonomous Driving Optical Networks”based on LOONG testbed !',
          time: '[09/2024]'
        },
        item4: {
          title: 'Prof. Zhuge is invited to give a talk in OFC 2025!',
          time: '[09/2024]'
        }
      }
    },
    demopage: {
      testbed_title: 'Testbed',
      demo_title: 'Demo',
      testbed_text: 'The field-deployed testbed with commercial equipment starts from Shanghai via Jiaxing to Hangzhou in China. It consists of a 440-km loop link with four spans of G.652.D fibers and six OAs. The testbed supports millisecond-level telemetry data collection. These telemetry data are transmitted through the optical supervisory channel (OSC) to the SDN server.',
      tasks: {
        item1: {
          title: 'Task 1: Failure management',
          description: `In the fiber aging management, the Agent’s integrated time series forecasting module triggers the handling process when predicting a 5-dB optical power degradation. The Planner then autonomously generates a workflow using the LLM. Following this workflow, the Agent retrieves relevant documentation and queries real-time optical power measurements to calculate the attenuation value of each span, which is then compared with the standard value. Based on the comparison and analysis, the Agent can localize the fiber with anomalous attenuation. After that, the Agent can reconfigure the optical amplifiers to mitigate the transmission performance degradation. The implementation results demonstrate LLM’s strong reasoning capability as it can process diverse failure-related information across multiple sources and formats.`
        },
        item2: {
          title: 'Task 2: Autonomous power optimization',
          description: `This demo explore the possibilities offered by LLMs to conduct power optimization in the LLM-native mode. The system utilizes LLM as a direct optimizer through the M.C. module, generating configuration suggestions via Planner and deploying them to the experimental testbed through the M.A. module. Using six amplifier gains as optimization parameters, the system evaluates optimization effectiveness through the average Q-factor of six receivers. Based on the ReAct framework, LLMs perform optimization through observe-think-act loops. The record shows how the LLM formulates a strategic plan (dividing the optimization into exploration and refinement phases), executes actions ('set_all_EDFAgain'), observes the results (Q_average), and demonstrates reasoning in its thought process for subsequent steps. Results show that the average Q-factor is successfully improved by LLM’s optimization.`
        }
      }
    },
    newspage: {
      news: {
        item1: {
          title:'The website of LOONG project is established!',
          time: '[01/2025]'
        },
        item2: {
          title: 'Two papers based on LOONG testbed are accepted by OFC 2025!',
          time: '[12/2024]'
        },
        item3: {
          title: 'We are happy to share our latest work named “First Field Trial of LLM-Powered AI Agent for Lifecycle Management of Autonomous Driving Optical Networks”based on LOONG testbed !',
          time: '[09/2024]'
        },
        item4: {
          title: 'Prof. Zhuge is invited to give a talk in OFC 2025!',
          time: '[09/2024]'
        }
      }
    },
    publicationpage: {
      publications_1: {
        item1: {
          description: {
            item1: {
              content: 'We design and demonstrate the first field trial of LLM-powered AI Agent for ADON. Three operation modes of the Agent are proposed for network lifecycle management. The Agent efficiently processes wavelength add/drop and soft/hard failures, and achieves comparable performance to human-designed algorithms for power optimization.',
              link: ''
            }
          }
        },
        item2: {
          description: {
            item1: {
              content: 'We propose a trusted optical power optimization strategy for ADON. Field trial experiments demonstrate reliable optimization while maintaining a 4-dB Q-factor margin. System performance remains above the threshold even with an initial 0.15-dB Q-factor margin.'
            }
          }
        },
        item3: {
          description: {
            item1: {
              content: 'We propose a heuristic-based optimization scheme for reliable optical amplifier reconfiguration process in ADON. In the experiment on a commercial testbed, the scheme prevents a 1.0-dB Q-factor degradation and outperforms 98.5% random solutions.'
            }
          }
        }
      },
      publications_2: {
        item1: {
          description: {
            item1: {
              content: 'In this tutorial, we introduce and discuss three key technologies, including modeling, telemetry, and self-learning, to build a DT for optical networks. The principles and progress of these technologies on major impairments that affect the quality of transmission are presented, and a discussion on the remaining challenges and future research directions is provided.',
              link: ''
            }
          }
        },
        item2: {
          description: {
            item1: {
              content: 'In this work, we propose a Bayesian inference framework (BIF) to construct the digital twin of OAs and control OPE in a data-efficient manner. Only the informative data are collected to balance the exploration and exploitation of the data space, thus enabling efficient autonomous-driving optical networks (ADONs). Simulations and experiments demonstrate that the BIF can reduce the data size for modeling erbium-doped fiber amplifiers by 80% and Raman amplifiers by 60%. '
            }
          }
        },
        item3: {
          description: {
            item1: {
              content: 'In this paper, we propose a novel scheme called SMOF — simultaneous modeling and optimization framework, which conducts RA modeling and gain profile optimization simultaneously. By iteratively freezing and unfreezing the inner parameters of the DT, the pump configuration is adjusted to achieve a desirable gain profile. ',
              link: ''
            }
          }
        },
        item4: {
          description: {
            item1: {
              content: 'In this paper, an input-parameter refinement (IR) paradigm aiming at finding the mappings from uncertain parameters to their corresponding true values is proposed. The primary advantage of the IR paradigm, as demonstrated in this study for Raman amplifiers (RAs), lies in its applicability to dynamic optical networks, where system parameters such as loading conditions and optical device configurations are subject to frequent variations. The use of the proposed paradigm to refine the model of RAs is discussed in detail. Results show the proposed IR scheme can lower the physics-based RA model’s mean prediction error from ∼0.92 dB to ∼0.20 dB and lower the maximum absolute error (MAE) from ∼3.09 dB to ∼1.12 dB.'
            }
          }
        }
      }
    },
    timeline: {
      event1: {
        date: 'June',
        title: 'Project Start',
        description: ''
      },
      event2: {
        date: 'September',
        title: 'Testbed Establishment',
        description: 'The lab testbed is established in Shanghai Jiao Tong University'
      },
      event3: {
        date: 'June',
        title: 'Field Trial Testbed Establishment',
        description: 'The field trial testbed extends from Shanghai through Jiaxing to Hangzhou'
      },
      event4: {
        date: 'Septempber',
        title: 'First Demonstration of LLM-powered Agent for Optical Network Lifecycle Management',
        description: 'First demonstration of LLM-powered agent for optical network lifecycle management is achieved in the field trial'
      }
    },
    nav_list: {
      Home: {
        text: 'Home'
      },
      Demo: {
        text: 'Demo'
      },
      Publications: {
        text: 'Publications'
      },
      News: {
        text: 'News'
      },
      Team: {
        text: 'Team'
      }
    },
    grouppage: {
      group_title: 'Group Members'
    }
  }
}
